var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9998,
    cy: 14,
    r: 13,
    fill: "#1E716A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9997 27.9999C21.7317 27.9999 27.9997 21.7319 27.9997 14C27.9997 6.268 21.7317 0 13.9997 0C6.26776 0 -0.000244141 6.268 -0.000244141 14C-0.000244141 21.7319 6.26776 27.9999 13.9997 27.9999ZM11.0399 11.1626V18.9418H8.39184V11.1626H11.0399ZM11.2144 8.75676C11.2144 9.50327 10.6396 10.1007 9.71634 10.1007H9.7161H9.69898C8.8102 10.1007 8.23565 9.50327 8.23565 8.75676C8.23565 7.9933 8.82755 7.41263 9.73392 7.41263C10.6396 7.41263 11.197 7.9933 11.2144 8.75676ZM15.1534 18.9418H12.5055C12.5058 18.8958 12.5401 11.8902 12.5058 11.1628H15.1536V12.2641C15.5055 11.7341 16.1355 10.9803 17.5402 10.9803C19.2824 10.9803 20.5886 12.0921 20.5886 14.4815V18.9418H17.9407V14.7806C17.9407 13.7347 17.5573 13.0214 16.5994 13.0214C15.8677 13.0214 15.432 13.5025 15.2406 13.9672C15.1707 14.1331 15.1534 14.3658 15.1534 14.598V18.9418ZM12.5055 18.942V18.9418V18.942Z",
    fill: "#0B0F14"
  })));
}

export default SvgLinkedin;